import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { ONE_STOP_PATH } from 'domain/shared/oneStop';
import { ListProvider, StaticFilters } from 'framework/list';
import { useShowContext } from 'framework/show';
import { ShowSection } from 'framework/ui/layout';
import { ProjectSectionAccordion, TeamShowType } from 'domain/shared/newProject';
import AssignmentsBlockHeader from 'domain/staffing/dashboard/dashboard/shared/staffingContent/assignments/AssignmentsBlockHeader';
import { useAssignmentsBlock } from 'domain/staffing/dashboard/dashboard/shared/staffingContent/assignments/useAssignmentsBlock';
import { useStaffingProjectContext } from '../context/StaffingProjectContext';
import { mapTeamStructureWithAssignments } from 'domain/shared/assignment/mapTeamStructureWithAssignments';
import { StaffingProjectAssignment, StaffingProjectData } from 'domain/shared/staffing';
import AssignmentsList from '../../dashboard/dashboard/shared/staffingContent/assignments/List/AssignmentsList';

const StaffingAssignmentsLayout = () => {
  const navigate = useNavigate();
  const { data, setData } = useShowContext<TeamShowType>();
  const teamData = data.getData();
  const { project, staffingData } = useStaffingProjectContext();
  const baseProjectData = staffingData || project;
  const teamAssignments = (teamData as TeamShowType & { assignments?: StaffingProjectAssignment[] }).assignments;
  const projectData: StaffingProjectData = {
    ...baseProjectData,
    name: baseProjectData?.name || project.name,
    projectManager: baseProjectData?.projectManager,
    team: teamData.team,
    budget: teamData.budget || project.budget,
    assignments: teamAssignments || staffingData?.assignments || [],
  };
  const mappedTeamStructure = mapTeamStructureWithAssignments(projectData, teamData.team).team.expectedStructure;
  const { contextValue, assignmentsFilters } = useAssignmentsBlock(mappedTeamStructure);

  return (
    <ListProvider value={contextValue}>
      <StaticFilters>
        <ShowSection sx={{ '&.section-details__wrapper': { p: '0px !important' } }}>
          <ProjectSectionAccordion
            defaultExpanded
            title={
              <AssignmentsBlockHeader
                assignmentsFilters={assignmentsFilters}
                onRequestVacancy={() => navigate(`${ONE_STOP_PATH}/REC04-NEW`)}
                variant="staffing"
              />
            }
          >
            <Box minWidth="1000px">
              <Box padding={1} px={2}>
                <AssignmentsList projectData={projectData} setProjectData={setData} />
              </Box>
            </Box>
          </ProjectSectionAccordion>
        </ShowSection>
      </StaticFilters>
    </ListProvider>
  );
};

export default StaffingAssignmentsLayout;
